import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactAddUpdateComponent } from './contact-add-update/contact-add-update.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'src/app/core/core.module';
import { LinkViewComponentComponent } from './link-view-component/link-view-component.component';

@NgModule({
  declarations: [ContactAddUpdateComponent, LinkViewComponentComponent],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    CoreModule
  ],
  exports:[
    ContactAddUpdateComponent,
    LinkViewComponentComponent
  ]
})
export class CommonComponentModule { }
